var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card',{staticClass:"mt-5 mb-8"},[_c('center',[(_setup.initQrCode)?_c(_setup.VueQrcode,{attrs:{"value":_setup.qrcodeString,"options":{ width: 200 }}}):_vm._e()],1),_c(_setup.BasicUserInfo,{attrs:{"coach-enable":true,"user-record":_setup.internalUserData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }